import { h } from 'preact';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

function Paragraph({ align, children, ...props }) {
    return (
        <_Div
            align={align}
            dangerouslySetInnerHTML={{ __html: children }}
            {...props}
        />
    );
}

Paragraph.propTypes = {
    size: PropTypes.oneOf(['sm', 'lg']),
    align: PropTypes.oneOf(['left', 'right', 'center']),
};

Paragraph.defaultProps = {
    size: 'lg',
    align: 'left',
};

const _Div = styled.div`
    font-size: 16px;
    line-height: 1.5;
    color: #20366a;
    text-align: ${({ align }) => align || 'left'};

    @media screen and (min-width: 45em) {
        font-size: 20px;
    }

    p {
        margin-top: 0;
    }

    a {
        text-decoration: none;
        color: #007bc2;
        font-weight: bold;
    }

    *:last-child {
        margin-bottom: 0;
    }

    ${({ size }) =>
        size === 'sm'
            ? css`
                  font-size: 14px;
                  margin-top: 20px;
                  line-height: 1.5;
                  color: #20366a;

                  @media screen and (min-width: 45em) {
                      font-size: 16px;
                  }
              `
            : ''}
`;
export default Paragraph;
